
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]",
      function () {
        return require("private-next-pages/[market]/[language]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]"])
      });
    }
  